// src/pages/simulations.tsx
import React from 'react';

import { PageProps, graphql } from 'gatsby';
import styled from 'styled-components';

import SimulationsIndexPage from 'stile-shared/src/components/2024/common/Simulations/SimulationsIndexPage';
import { Simulation } from 'stile-shared/src/utils/simulations';

import { PageLayout } from 'templates/2024/PageLayout';

export { Head } from 'templates/2024/Head';

const SimulationsPageLayout = styled(PageLayout)`
  .grid-layout {
    margin: 0 auto;
  }

  .main-content {
    margin: 0 auto;
    padding-bottom: 120px;

    @media (max-width: 768px) {
      margin: 0 auto;
      padding-bottom: calc(60px - 28px);
    }
  }
`;

type SimulationsIndexPagePageProps = PageProps & {
  data: Queries.allSimulationsQuery;
};

function SimulationsPage({ data, ...props }: SimulationsIndexPagePageProps) {
  return (
    <SimulationsPageLayout {...props}>
      <SimulationsIndexPage
        allSimulations={
          data?.allSimulations.nodes.flatMap((node: any) =>
            node.getResponses.map((r: any) => r.simulation)
          ) as Simulation[]
        }
        region="us"
      />
    </SimulationsPageLayout>
  );
}

export const query = graphql`
  query allSimulations {
    allSimulations {
      nodes {
        getResponses {
          simulation {
            namePlaintext
            coverImageUrl
            scienceDisciplines
            gradeLevelsOnlyForMarketing
            shortDescriptionLocalised {
              fallbackLocale
              localeToProsemirror
            }
          }
        }
      }
    }
  }
`;

export default SimulationsPage;
